import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { AppEffectsModule } from './effects';
import { reducers } from '@appStore/app/reducers';
import * as fromServices from '@appStore/app/services';

export * from '@appStore/app/reducers';
export * from '@appStore/app/effects';
export * from '@appStore/app/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('app', reducers), AppEffectsModule],
  providers: [...fromServices.services ]
})
export class AppStoreModule {}